// src/utils/formDefaults.ts
// This file contains large default objects with many identical null/false values.
// Duplication here is intentional and unavoidable — it's configuration data, not logic.
// Refactoring would reduce readability and type safety.
// See: https://sonarqube.company.com/coding_rules#rule_key=typescript%3AS1186

/* sonar-disable typescript:S1186 */
export const DEFAULT_SERVE_PREFERENCES = {
  isPatientAddress: false,
  isPatientAccountNumber: false,
  isPatientFullSSNNumber: false,
  isPatientInitialSensitiveInformation: false,
  isElectronicSignatureAccepted: false,
  isRequiredDateOfLoss: false,
  isClaimNumber: false,
  isAuthorizationWithSubpoenaRequired: false,
  isPOAForSubpoena: false,
  isHIPPAAuthorizationOriginal: false,
  isFacilitySpecificAuthorization: false,
  facilitySpecificAuthorizationNotes: null,
  isAcceptLOR: false,
  acceptLORNotes: null,
  isSOAForSubpoena: false,
  isCopyService: false,
  copyServiceNotes: null,
  isAdditionalFacilitySpecificDocumentation: false,
  additionalFacilitySpecificDocumentationNotes: null,
  isRequiresSpecificDatesOfService: false,
  isRequiresDOB: false,
  isRequiresThirdPartyListedOnAuthSubpoena: false,
  isRequiresDeathCertificate: false,
  isRequiresEstateLetter: false,
  isRequiresCertificationOfNonObjection: false,
  isRequiresCertificationOfNotice: false,
  isMultipleStatusFollowUps: false,
  isRequiresRecordTypeAndScopeInAuth: false,
  files: [] as any[],
} as const;
/* sonar-enable typescript:S1186 */

export const DEFAULT_BILLING_INFO = {
  payeeName: null,
  payeeAddress: null,
  payeeContact: null,
  payeeCity: null,
  payeePostCode: null,
  payeeStateId: null,
  processingFeesAuthorization: null,
  processingFeesSubpoena: null,
  invoiceBeforeRecords: false,
  invoicePaymentMethods: [] as any[],
  processingFeesMethods: [] as any[],
  initialProcessingFee: false,
  initialProcessingFeeNotes: null,
} as const;

export const EMPTY_FORM_EXPECTATION = {
  id: undefined,
  name: undefined,
  isFacility: undefined,
  isCustodian: undefined,
  notes: undefined,
  disabled: false,
  facilityTypes: [],
  facilityTypeNotes: undefined,
  addressInfo: { addressDetails: null, city: null, stateId: null, postCode: null, timeZoneId: null },
  mailingAddress: { addressDetails: '', city: '', stateId: '', postCode: '', timeZoneId: null },
  emails: [{ email: '', hasDuplicateError: false }],
  portalUrls: [{ portalUrl: '', portalTypeId: null, portalNotes: null, hasDuplicateError: false }],
  externalSourceMappings: [{ mappedId: '', sourceTypeId: null, notes: null }],
  phones: [],
  contacts: [{ isPrimary: false, email: '', phoneNumber: '', name: '', title: '' }],
  departmentAndPhysicians: [{ department: null, name: null, phoneNumber: null, additionalInformation: null }],
  custodianDetails: {
    recordTypes: [],
    recordTypeNotes: undefined,
    orderTypeName: undefined,
    orderTypeId: undefined,
    orderTypeNotes: undefined,
    daysAvailable: [],
    serveMethods: [],
    roiMethods: [],
    serveMethodNotes: '',
    roiMethodNotes: '',
    followUpMethods: [],
    entityMetric: { averageProcessingTime: null, lastRecordRetrievedDate: null },
    servePreferences: DEFAULT_SERVE_PREFERENCES,
    billingInformation: DEFAULT_BILLING_INFO,
  },
} as const;